export const nl = {
  // Common
  "common.back": "Terug",
  "common.cancel": "Annuleren",
  "common.noItems": "Geen items",
  "common.loading": "Laden...",
  
  // Header
  "nav.features": "Functies",
  "nav.howItWorks": "Hoe het werkt",
  "nav.pricing": "Prijzen",
  "nav.faq": "FAQ",
  "nav.testimonials": "Showcase",
  "nav.contact": "Contact",
  "button.getStarted": "Aan de slag",
  "button.loading": "Laden...",
  
  // Auth related
  "auth.signIn": "Inloggen",
  "auth.redirecting": "Doorverwijzen...",
  "auth.continueWithGoogle": "Doorgaan met Google",
  "auth.continueWithGithub": "Doorgaan met GitHub",
  "auth.or": "OF",
  
  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",
  
  // Hero Section
  "hero.title": "AI-Aangedreven Communicatie Assistent",
  "hero.subtitle": "Transformeer je gesprekken met intelligente, contextbewuste antwoorden die je helpen effectiever te communiceren in elke situatie.",
  "hero.cta.primary": "Gratis Proefperiode",
  "hero.cta.secondary": "Bekijk Demo",
  
  // Main Title
  "main.title": "Verander Elk Antwoord in een Kans",
  
  // Footer Section
  "footer.company": "Bedrijf",
  "footer.product": "Product",
  "footer.support": "Ondersteuning",
  "footer.legal": "Juridisch",
  "footer.contactSupport": "Contact Ondersteuning",
  "footer.helpCenter": "Helpcentrum",
  "footer.apiDocs": "API Documentatie",
  "footer.statusPage": "Status Pagina",
  "footer.privacyPolicy": "Privacybeleid",
  "footer.termsOfService": "Servicevoorwaarden",
  "footer.cookiePolicy": "Cookiebeleid",
  "footer.refundPolicy": "Terugbetalingsbeleid",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Ondersteuning",
  
  // Features Section
  "features.badge": "Krachtige Functies",
  "features.title": "Alles wat je nodig hebt voor Betere Communicatie",
  "features.subtitle": "Uitgebreide tools ontworpen om elk gesprek effectiever en professioneler te maken.",
  "features.scenario.title": "Scenario Sjablonen",
  "features.scenario.description": "Voorgebouwde sjablonen voor werkplek, persoonlijke, academische en professionele communicatie.",
  "features.custom.title": "Aangepaste Invoer",
  "features.custom.description": "Plak elk bericht of inhoud en krijg contextueel passende antwoorden.",
  "features.instant.title": "Verkort antwoordtijd met 90%",
  "features.instant.description": "Krijg AI-gemaakte antwoorden in enkele seconden. Geen wachten, alleen resultaten.",
  "features.copy.title": "Eén-klik Kopiëren & Delen",
  "features.copy.description": "Kopieer antwoorden direct of deel ze rechtstreeks vanaf het platform.",
  
  // How It Works Section
  "howItWorks.badge": "Hoe het werkt",
  "howItWorks.title": "Drie Eenvoudige Stappen naar Betere Communicatie",
  "howItWorks.subtitle": "Ons gestroomlijnde proces maakt het gemakkelijk om professionele antwoorden te genereren voor elke situatie.",
  "howItWorks.step1.title": "Selecteer Scenario",
  "howItWorks.step1.description": "Kies het communicatiescenario dat het beste bij je behoeften past.",
  "howItWorks.step2.title": "Plak Inhoud",
  "howItWorks.step2.description": "Voeg het bericht of de inhoud toe waarop je moet reageren.",
  "howItWorks.step3.title": "Krijg AI Antwoord",
  "howItWorks.step3.description": "Ontvang een professioneel, contextueel antwoord in seconden.",
  
  // Pricing Section
  "pricing.title": "Prijzen",
  "pricing.subtitle": "Kies het plan dat past bij je communicatiebehoeften",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/maand",
  "pricing.free.description": "Perfect om onze service uit te proberen",
  "pricing.pro.description": "Ideaal voor professionals en frequente gebruikers",
  "pricing.business.description": "Voor teams en organisaties",
  "pricing.popular": "Meest Populair",
  "pricing.free.feature1": "10 antwoorden per maand",
  "pricing.free.feature2": "Basis scenario",
  "pricing.free.feature3": "Definieer & gebruik sjablonen",
  "pricing.free.feature4": "Historische antwoord records",
  "pricing.pro.feature1": "200 antwoorden per maand",
  "pricing.pro.feature2": "Basis+Aangepast scenario",
  "pricing.pro.feature3": "Definieer & gebruik sjablonen",
  "pricing.pro.feature4": "Historische antwoord records",
  "pricing.pro.feature5": "Geavanceerde aanpassing",
  "pricing.business.feature1": "Onbeperkte antwoorden",
  "pricing.business.feature2": "Team samenwerking",
  "pricing.business.feature3": "Basis+Aangepast scenario",
  "pricing.business.feature4": "Definieer & gebruik sjablonen",
  "pricing.business.feature5": "Historische antwoord records",
  "pricing.business.feature6": "Geavanceerde aanpassing",
  "pricing.cta.trial": "Start Gratis Proefperiode",
  "pricing.cta.subscribe": "Abonneren",
  "pricing.cta.contact": "Contact Verkoop",
  "pricing.cta.current": "Huidig Plan",
  "pricing.currentPlan": "Huidig Plan:",
  "pricing.endDate": "Einddatum huidig plan:",
  "pricing.autoRenewalDate": "Automatische vernieuwingsdatum huidig plan:",
  "pricing.answersLeft": "Resterende antwoorden:",
  "pricing.planName.free": "Free Plan",
  "pricing.planName.proMonthly": "Pro Plan-Maandelijks",
  "pricing.planName.proYearly": "Pro Plan-Jaarlijks",
  "pricing.planName.maxMonthly": "Enterprise Plan-Maandelijks",
  "pricing.planName.maxYearly": "Enterprise Plan-Jaarlijks",
  "pricing.autoRenews": "Je antwoordtelling vernieuwt automatisch op:",
  "pricing.needMore": "Meer antwoorden nodig?",
  "pricing.upgradeBelow": "Upgrade je plan hieronder",
  "pricing.doNotRollOver": "Ongebruikte antwoorden worden niet overgedragen",
  
  // FAQ Section
  "faq.title": "Veelgestelde Vragen",
  "faq.subtitle": "Alles wat je moet weten over communicate2win",
  "faq.q1": "Welke communicatiescenario's worden ondersteund?",
  "faq.a1": "We ondersteunen werkplekommunicatie, persoonlijke relaties, academische correspondentie, klantenservice, verkoopactiviteiten en vele andere scenario's. Onze AI past zich aan de context en toon aan die voor elke situatie vereist is.",
  "faq.q2": "Hoe snel worden antwoorden gegenereerd?",
  "faq.a2": "Onze AI genereert antwoorden in enkele seconden. We geven prioriteit aan snelheid zonder kwaliteit in te leveren, zodat je direct professionele antwoorden krijgt.",
  "faq.q3": "Kan ik mijn abonnement op elk moment opzeggen?",
  "faq.a3": "Ja, je kunt je abonnement op elk moment opzeggen. Er zijn geen langetermijnverplichtingen en je kunt je plan naar behoefte downgraden of upgraden.",
  "faq.q4": "Zijn mijn gegevens veilig en privé?",
  "faq.a4": "Ja, we implementeren uitgebreide beveiligingsmaatregelen inclusief encryptie, toegangscontroles en regelmatige beveiligingsaudits. Je invoerinhoud en gegenereerde antwoorden worden opgeslagen als onderdeel van je gebruikersgeschiedenis om functies zoals antwoordbeoordeling en sjablooncreatie mogelijk te maken. Je kunt je geschiedenisgegevens op elk moment verwijderen via je accountinstellingen.",
  "faq.q5": "Wat als mijn Replies op zijn?",
  "faq.a5": "Free-gebruikers moeten wachten tot de volgende maandcyclus voor vernieuwing. Na een upgrade naar Pro kun je extra eenmalige Replies kopen; deze extra Replies zijn alleen geldig in de huidige maandcyclus. Enterprise-gebruikers hebben onbeperkte Replies.",
  "faq.q6": "Welke talen worden ondersteund?",
  "faq.a6": "Momenteel ondersteunen we Engels met plannen om uit te breiden naar Spaans, Frans, Duits en andere hoofdtalen. De AI kan meertalige communicatie effectief hanteren.",
  
  // Testimonials Section
  "testimonials.title": "Communicatie Showcase",
  "testimonials.subtitle": "Openbare berichten, e-mails en AI-gepolijste antwoorden om je eigen te inspireren",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Marketing Directeur",
  "testimonials.sarah.quote": "communicate2win heeft getransformeerd hoe ik klantcommunicatie behandel. De antwoorden zijn professioneel en besparen me elke week uren.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Verkoop Manager",
  "testimonials.michael.quote": "De werkplek scenario sjablonen zijn ongelooflijk accuraat. Mijn responspercentage is met 40% verbeterd sinds ik deze tool gebruik.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Klant Succes Lead",
  "testimonials.emily.quote": "Perfect voor het hanteren van moeilijke klantsituaties. De AI begrijpt context en toon perfect.",
  
  // Interface Elements
  "interface.generating": "Antwoord Genereren...",
  "interface.generate": "Genereer AI Antwoord",
  "interface.processing": "Verwerken...",
  
  // History and Showcase
  "history.shareToShowcase": "Delen naar Showcase",
  "history.showcased": "In showcase",
  "history.shareConfirm": "Dit bericht delen naar de Showcase? Deze actie kan niet ongedaan worden gemaakt tenzij je het bericht verwijdert.",
  "history.sharedBy": "Gedeeld door:",
  "interface.copy": "Kopiëren",
  "interface.share": "Delen",
  "interface.shareResponse": "Antwoord Delen",
  "interface.shareNative": "Delen via Systeem",
  "interface.shareEmail": "E-mail",
  "interface.copyShareText": "Kopiëren met Link",
  "interface.shareTextCopied": "Antwoord en link gekopieerd naar klembord.",
  "interface.ready": "Klaar om te Genereren",
  "interface.enterMessage": "Voer je berichtinhoud in en selecteer een scenario om te beginnen met AI-aangedreven antwoorden.",
  "interface.fast": "Snel",
  "interface.accurate": "Nauwkeurig",
  "interface.professional": "Professioneel",
  "interface.translation": "Vertaling",
  "interface.responseDescription": "Hier is een doordacht en professioneel antwoord afgestemd op de context:",
  "interface.multipleOptions": "Meerdere antwoordopties:",
  "interface.option": "Optie",
  "interface.noContent": "Geen inhoud beschikbaar",
  
  // Placeholders
  "placeholder.message": "Plak het bericht waarop je reageert, e-mailinhoud of tekst die je hebt ontvangen...",
  
  // Dropdowns
  "dropdown.useTemplates": "Gebruik Sjablonen",
  "dropdown.scenario": "Geen Scenario",
  "dropdown.target": "Geen Doel",
  "dropdown.tone": "Geen Toon",
  
  // Scenario Options
  "scenario.email": "E-mail",
  "scenario.message": "Bericht",
  "scenario.workplace": "Werkplek",
  "scenario.school": "School",
  "scenario.home": "Thuis",
  "scenario.business": "Zakelijk",
  "scenario.academic": "Academisch",
  "scenario.social": "Sociaal",
  "scenario.formal": "Formeel",
  "scenario.casual": "Informeel",
  "scenario.professional": "Professioneel",
  "scenario.personal": "Persoonlijk",
  "scenario.customerService": "Klantenservice",
  "scenario.interview": "Interview",
  "scenario.presentation": "Presentatie",
  
  // Target Options
  "target.lover": "Partner",
  "target.friend": "Vriend",
  "target.boss": "Baas",
  "target.colleague": "Collega",
  "target.classmate": "Klasgenoot",
  "target.parents": "Ouders",
  "target.child": "Kind",
  "target.teacher": "Leraar",
  "target.student": "Student",
  "target.client": "Klant",
  "target.customer": "Klant",
  "target.stranger": "Vreemdeling",
  "target.family": "Familie",
  "target.sibling": "Broer/Zus",
  "target.neighbor": "Buur",
  "target.mentor": "Mentor",
  "target.supplier": "Leverancier",
  "target.serviceProvider": "Serviceverlener",
  "target.partner": "Partner",
  "target.subordinate": "Ondergeschikte",
  
  // Tone Options
  "tone.humorous": "Humoristisch",
  "tone.serious": "Serieus",
  "tone.happy": "Blij",
  "tone.angry": "Boos",
  "tone.mischievous": "Ondeugende",
  "tone.polite": "Beleefd",
  "tone.casual": "Informeel",
  "tone.formal": "Formeel",
  "tone.friendly": "Vriendelijk",
  "tone.confident": "Zelfverzekerd",
  "tone.apologetic": "Verontschuldigend",
  "tone.enthusiastic": "Enthousiast",
  
  // Status Messages
  "status.copied": "Gekopieerd!",
  "status.copyDescription": "Antwoord gekopieerd naar klembord.",
  "status.copyWithTranslationDescription": "Antwoord en vertaling gekopieerd naar klembord.",
  "status.success": "Antwoord succesvol gegenereerd. ",
  "status.successWithTranslation": "Antwoord gegenereerd met vertaling.",
  "status.successWithoutTranslation": "Antwoord succesvol gegenereerd.",
  "status.error": "Genereren mislukt",
  "status.errorDescription": "Kon antwoord niet genereren. Probeer opnieuw.",
  "status.enterContent": "Voer inhoud in",
  "status.enterContentDescription": "Voeg het bericht toe waarop je wilt reageren.",
  
  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Beschrijving (optioneel)",
  "restriction.descriptionLabel": "Beschrijving (Alleen voor Pro / Enterprise abonnees)",
  "restriction.proMaxOnly": "* Alleen voor Pro / Enterprise abonnees",
  "restriction.desPrompt": "Voer context, achtergrondinformatie of specifieke vereisten in die kunnen helpen betere antwoorden te genereren...",
  
  // Demo functionality for non-logged-in users
  "demo.title": "Selecteer een bericht om op te reageren",
  "demo.option1": "Verkoop opener (koude benadering)",
  "demo.option2": "Omgaan met een \"jullie prijs is hoog\" onderzoek",
  "demo.option3": "Interview zelfintroductie (30-seconden versie)",
  "demo.option4": "E-mail antwoord",
  "demo.option5": "Follow-up voor een \"gelezen-maar-geen-antwoord\" prospect",
  "demo.option6": "Elevator pitch (30 seconden)",
  "demo.runDemo": "Demo Uitvoeren",
  "demo.inputContent": "Invoer Inhoud:",
  "demo.scenario": "Scenario:",
  "demo.target": "Doel:",
  "demo.tone": "Toon:",
  "demo.description": "Beschrijving:",

  // User Menu
  "userMenu.myAccount": "Mijn Account",
  "userMenu.history": "Geschiedenis",
  "userMenu.templates": "Sjablonen",
  "userMenu.signOut": "Uitloggen",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "AI Antwoord Voorbeeld",
  "hero.preview.scenarioLabel": "Scenario",
  "hero.cta.tryNow": "Gratis Beginnen",
  "hero.cta.learnMore": "Meer Leren",
  "hero.cta.getStarted": "Gratis Beginnen",
  "hero.preview.primary": "Toon Polijsten",
  "hero.preview.secondary": "Vertalen",
  "hero.preview.tone": "Vriendelijk",
  "hero.preview.target": "Klant",
  "hero.hook": "Sluit je aan bij duizenden gebruikers die dagelijks hun communicatie verbeteren.",
  "hero.headline": "AI-Aangedreven Communicatie Assistent",
  "hero.subheadline": "Transformeer ruwe ideeën in enkele seconden naar gepolijste, contextbewuste antwoorden.",
  
  // Stats
  "stats.users": "Gebruikers",
  "stats.replies": "Antwoorden",
  "stats.languages": "Talen",
  
  // Marquee / Logos
  "marquee.trusted": "Partners / Support",
  "marquee.aria": "Merklogo's",
  
  // Interface Elements (additional)
  "interface.advancedOptions": "Geavanceerde Opties",
  "interface.clearInput": "Invoer Wissen",
  "interface.clearDescription": "Beschrijving Wissen",
  
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Verkoop opener",
  "demo.shortTitle.priceObjection": "Prijs onderzoek",
  "demo.shortTitle.interviewIntro": "Interview intro",
  "demo.shortTitle.emailReply": "E-mail antwoord",
  "demo.shortTitle.followUp": "Opvolging",
  "demo.shortTitle.elevatorPitch": "Elevator pitch",
  
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "Invoer Prompt",
  "demoTabs.context": "Context",
  "demoTabs.description": "Beschrijving",
  "demoTabs.generate": "Genereren",
  "demoTabs.aiOutput": "AI Uitvoer",
  "demoTabs.sample": "voorbeeld",
  "demoTabs.streaming": "Streaming tokens...",
  
  // Preview sections
  "preview.section.scenarioTemplates.title": "Scenario & Sjablonen",
  "preview.section.scenarioTemplates.subtitle": "Kies snel een scenario of pas een opgeslagen sjabloon toe. Sjablonen vullen beschrijving/doel/toon vooraf in zodat je direct hoogwaardige generatie kunt starten.",
  "preview.section.customInputs.title": "Aangepaste Invoer",
  "preview.section.customInputs.subtitle": "Kern invoer + optionele beschrijving + geavanceerde Scenario/Doel/Toon selectoren. Combineer vrij voor contextbewuste resultaten.",
  "preview.section.cutReplyTime.title": "Verkort Antwoordtijd met 90%",
  "preview.section.cutReplyTime.subtitle": "Vergelijk handmatig opstellen vs AI-assistentie. Parallelle opties + ingebouwde vertaling verminderen revisielussen.",
  "preview.section.copyShare.title": "Eén-klik Kopiëren & Delen",
  "preview.section.copyShare.subtitle": "Meerdere opties uitgelegd met geünificeerde top acties: kopieer alles / deel / per-optie kopiëren. Vertaling automatisch toegevoegd.",
  
  "preview.templates.my": "Mijn Sjablonen",
  "preview.templates.new": "Nieuw",
  "preview.manualFlow": "Handmatige Flow",
  "preview.aiAssisted": "AI Ondersteund",
  
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Plan structuur & toon",
  "preview.manualFlow.step2": "Concept opening / verwijderen & herschrijven",
  "preview.manualFlow.step3": "Beleefdheid & grammatica aanpassen",
  "preview.manualFlow.step4": "Woordgebruik opzoeken + vertaling verifiëren",
  "preview.manualFlow.step5": "Plakken in doel-app",
  
  "preview.copyAll": "Alles Kopiëren",
  "preview.share": "Delen",
  "preview.enPlusTranslation": "NL + Vertaling",
  "preview.translationAppendNote": "(*) Vertaling wordt automatisch toegevoegd bij alles kopiëren.",
  "preview.field.scenario": "Scenario",
  "preview.field.target": "Doel",
  "preview.field.tone": "Toon",
  "preview.auto": "Auto",
  "preview.step.pasteOrTemplate": "Verzoek plakken of sjabloon kiezen",
  "preview.step.optionalDescription": "(Optioneel) beschrijving / scenario toevoegen",
  "preview.step.pickOption": "Kies één gegenereerde optie",
  "preview.step.copyShareTranslate": "Eén-klik kopiëren / delen / vertalen",
  "preview.time.manual": "5–8 min",
  "preview.time.ai": "30–40 sec",
  
  // Additional missing keys
  "auth.consent.prefix": "Door verder te gaan, ga je akkoord met onze",
  "auth.consent.terms": "Voorwaarden",
  "auth.consent.and": "en",
  "auth.consent.privacy": "Privacybeleid",
  
  "testimonials.more": "Klik galerij om volledige showcase te verkennen",
  
  "history.loadMoreButton": "Meer Laden",
  
  "pricing.willCancelOn": "Wordt geannuleerd op:",
  "pricing.downgradeScheduled": "Downgrade gepland. Zal overschakelen naar",
  "pricing.on": "op:",
  "pricing.upgradeImmediateTitle": "Plan geüpgraded",
  "pricing.upgradeImmediateDesc": "Je nieuwe plan is nu actief.",
  "pricing.downgradeScheduledTitle": "Downgrade gepland",
  "pricing.downgradeScheduledDesc": "Je plan zal veranderen bij de volgende vernieuwing.",
  "pricing.cancelScheduledTitle": "Annulering gepland",
  "pricing.cancelScheduledDesc": "Je plan eindigt aan het einde van de periode.",
  "pricing.cancelResumedTitle": "Annulering verwijderd",
  "pricing.cancelResumedDesc": "Je abonnement zal blijven vernieuwen.",
  "pricing.cancelPendingDowngrade": "Annuleren",
  "pricing.pendingDowngradeCanceledTitle": "Wachtende downgrade geannuleerd",
  "pricing.pendingDowngradeCanceledDesc": "Je plan blijft ongewijzigd.",
  "pricing.pendingDowngradeCancelFailedTitle": "Annuleren mislukt",
  "pricing.pendingDowngradeCancelFailedDesc": "Kon de wachtende downgrade niet annuleren. Probeer opnieuw.",
  "pricing.cancelPendingDowngradeProcessing": "Verwerken...",
  "pricing.scheduled": "Gepland",
  "pricing.processing": "Verwerken...",
  "pricing.getMoreReplies": "Meer Antwoorden Krijgen",
  "pricing.oneTimeTitle": "Voeg meer antwoorden toe aan je account",
  "pricing.oneTimeAmountLabel": "Bedrag (USD)",
  "pricing.repliesUnit": "Antwoorden",
  "pricing.oneTimeNotice": "Het aantal antwoorden dat je koopt is alleen geldig voor de huidige maandcyclus. Een actief betaald abonnement is vereist om ze te gebruiken en ongebruikte antwoorden worden niet overgedragen.",
  "pricing.cancel": "Annuleren",
  "pricing.proceed": "Doorgaan",
  "pricing.confirmUpgradeTitle": "Upgrade Bevestigen",
  "pricing.confirmDowngradeTitle": "Downgrade Bevestigen",
  "pricing.confirmUpgradeDesc": "Je staat op het punt je plan te upgraden. De wijziging wordt onmiddellijk van kracht en er kan een evenredige toeslag (of krediet) van toepassing zijn.",
  "pricing.confirmDowngradeDesc": "Je staat op het punt een downgrade in te plannen. Je huidige functies blijven tot het einde van de huidige factureringsperiode.",
  "pricing.downgradeEffectNote": "Downgrade geeft geen terugbetaling voor de huidige cyclus.",
  "pricing.downgradeApplyNextCycle": "Het nieuwe plan start automatisch bij vernieuwing.",
  "pricing.confirmCancel": "Terug",
  "pricing.confirmProceedUpgrade": "Nu Upgraden",
  "pricing.confirmProceedDowngrade": "Downgrade Inplannen",
  
  // Showcase Page
  "showcase.title": "Communicatie Showcase",
  "showcase.subtitle": "Ontdek inspirerende AI-aangedreven communicaties gedeeld door onze gemeenschap",
  "showcase.userPrefix": "Openbare communicaties door",
  "showcase.backAll": "Terug naar Alle Showcase",
  "showcase.sortBy": "Sorteren op:",
  "showcase.sort.newest": "Nieuwste Eerst",
  "showcase.sort.oldest": "Oudste Eerst",
  "showcase.sort.scenario": "Op Scenario",
  "showcase.sort.target": "Op Doel",
  "showcase.sort.tone": "Op Toon",
  "showcase.filter.scenario": "Scenario:",
  "showcase.filter.target": "Doel:",
  "showcase.filter.tone": "Toon:",
  "showcase.filter.all": "Alle",
  "showcase.loading": "Showcase laden...",
  "showcase.loadingUser": "Gebruiker communicaties laden...",
  "showcase.loadingMore": "Meer laden...",
  "showcase.none.userTitle": "Nog geen openbare communicaties",
  "showcase.none.globalTitle": "Nog geen showcase items",
  "showcase.none.userDesc": "Deze gebruiker heeft nog geen communicaties gedeeld naar de showcase.",
  "showcase.none.globalDesc": "Wees de eerste om je AI communicatie te delen naar de showcase!",
  "showcase.messageDetails": "Bericht Details",
  "showcase.field.date": "Datum",
  "showcase.field.scenario": "Scenario",
  "showcase.field.target": "Doel",
  "showcase.field.tone": "Toon",
  "showcase.originalMessage": "Origineel Bericht",
  "showcase.description": "Beschrijving",
  "showcase.aiResponse": "AI Antwoord",

  // Templates
  "templates.saveAsTemplate": "Opslaan als Sjabloon",
  "templates.saved": "Sjabloon Opgeslagen",
  "templates.saveSuccess": "Sjabloon succesvol opgeslagen",
  "templates.title": "Mijn Sjablonen",
  "templates.new": "Nieuw Sjabloon",
  "templates.loading": "Laden...",
  "templates.none": "Geen sjablonen gevonden",
  "templates.name": "Naam",
  "templates.scenario": "Scenario",
  "templates.target": "Doel",
  "templates.tone": "Toon",
  "templates.description": "Beschrijving",
  "templates.save": "Opslaan",
  "templates.saving": "Opslaan...",
  "templates.delete": "Sjabloon Verwijderen",
  "templates.deleteConfirm": "Dit sjabloon verwijderen?",
  "templates.deleteFailed": "Sjabloon verwijderen mislukt",
  "templates.nameRequired": "* Voer sjabloonnaam in",
  "templates.deleteSuccess": "Sjabloon succesvol verwijderd",
  "templates.saveFailed": "Sjabloon opslaan mislukt",

  // History Modal additions
  "history.messageDetails": "Bericht Details",
  "history.messageDetailsDesc": "Bekijk en beheer je berichtdetails, inclusief de originele invoer en AI-gegenereerde antwoord.",
  "history.field.date": "Datum",
  "history.field.scenario": "Scenario",
  "history.field.target": "Doel",
  "history.field.tone": "Toon",
  "history.originalMessage": "Origineel Bericht",
  "history.aiResponse": "AI Antwoord",
  "history.description": "Beschrijving",
  "history.listTitle": "Bericht Geschiedenis",
  "history.listDesc": "Blader, filter en beheer je gesprekgeschiedenis. Klik op elk bericht om details te bekijken.",
  "history.sortBy": "Sorteren op:",
  "history.sort.newest": "Nieuwste Eerst",
  "history.sort.oldest": "Oudste Eerst",
  "history.sort.scenario": "Op Scenario",
  "history.sort.target": "Op Doel",
  "history.sort.tone": "Op Toon",
  "history.filter.scenario": "Scenario:",
  "history.filter.target": "Doel:",
  "history.filter.tone": "Toon:",
  "history.filter.all": "Alle",
  "history.loading": "Geschiedenis laden...",
  "history.loadingMore": "Meer laden...",
  "history.none": "Geen berichten gevonden",
  "history.showing": "{current} van {total} berichten weergegeven",
  "history.allLoaded": "Alle berichten geladen",
  "history.scrollMore": "Scroll omlaag voor meer",
  "history.deleteMessage": "Bericht Verwijderen",
  "history.deleting": "Verwijderen...",
  "history.deleteSuccess": "Berichtrecord succesvol verwijderd",
  "history.deleteFailed": "Berichtrecord verwijderen mislukt, probeer opnieuw",
  "history.confirmDeleteTitle": "Verwijdering Bevestigen",
  "history.confirmDeleteSubtitle": "Deze actie kan niet ongedaan worden gemaakt",
  "history.confirmDeleteDesc": "Weet je zeker dat je dit berichtrecord wilt verwijderen?",
  "history.confirmDeleteAction": "Verwijdering Bevestigen",
  "history.shareTitle": "Delen naar Showcase",
  "history.shareSubtitle": "Maak dit bericht openbaar",
  "history.sharing": "Delen...",
  "history.confirmShareAction": "Delen Bevestigen",
  "history.shareSuccess": "Bericht succesvol gedeeld naar showcase",
  "history.shareFailed": "Delen naar showcase mislukt, probeer opnieuw"
};